<template>
    <div class="container" @click="onPress">
        <img class="img" src="../../assets/icon_liaoban.png" />
        <div class="p_title">
            聊伴测试包（点击下载）
        </div>
    </div>
</template>


<script>
import { is_weixin, isIos } from '../../common/functions';

export default {
    data() {
        return {
            index: 1,
        };
    },

    created() {
        document.title = "App下载";
    },

    mounted() {

    },

    methods: {
        onPress() {
            // console.log('on press si - - - - >');
            if (is_weixin()) {
                alert('请点击右上角使用外部浏览器打开后再进行下载!');
            } else {
                if (isIos()) {
                    window.location.href = 'http://www.baidu.com';
                } else {
                    window.location.href = 'https://km-distribution-1301744297.cos.ap-nanjing.myqcloud.com/liaoban_test.apk';
                }
            }
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.p_title {
    font-size: 20px;
    font-weight: 600px;
    align-self: center;
    justify-content: center;
    margin-bottom: 100px;
    margin: 40px 20px;
    /* font-style: italic */
}

.img {
    width: 40%;
    margin-top: 160px;
    margin-left: 30%;
}
</style>